import _ from "lodash";
import { config } from '../constant';
import { toastInformation } from "./common";
import store from "../../context/store/store";
import { Types } from "../../context/action/action";
import { closeCaptionmeetingState } from "../../models/callModel";

var player = new Audio();
export const StoreEditAutomatedMinutes = (custom:Array<any>) => {
  store.dispatch({
    type: Types.AUTOMATED_MINS_LIST_EDIT,
    payload: {
      editautomatedmins: custom
    }
  });
};

export const addTranscriptHighlight = (key: string) =>{
  let {highlights} = store.getState().closeCaption;
  highlights.push(key);
  store.dispatch({
    type: Types.TRANSCRIPTS_HIGHLIGHTS,
    payload: {
      highlights: highlights
    }
  });
  toastInformation('Highlights added successful','success')
};

export const removeTranscriptHighlight = (key: string) =>{
  let {highlights} = store.getState().closeCaption;
  let removhighlights = highlights.filter((item:any) => item !== key);
  store.dispatch({
    type: Types.TRANSCRIPTS_HIGHLIGHTS,
    payload: {
      highlights: removhighlights
    }
  });
  toastInformation('Highlights removed successful','success')

};

export const transcriptionSearch = (searchKey: string, transcript: any, filterBy: any) => {
  
  let closeCaption: closeCaptionmeetingState = store.getState().closeCaption || [];
  searchKey = searchKey.toLowerCase();
  if (closeCaption.asrCallingFrom === 'callList') {

    if (filterBy.length !== 0) {
      transcript = transcript.filter(function(o1: any) {
        return filterBy.some(function(o2: any) {
          return o1.speakerName === o2;
        });
      });
    }

    return _.filter(transcript, function(obj) {
      return (obj.text).toLowerCase().includes(searchKey) ||
        ((obj.convertedText || '').toString()).toLowerCase().includes(searchKey);
    });

  }
  else {

    return _.filter(transcript, function(obj) {
      return (obj.text).toLowerCase().includes(searchKey) ||
        ((obj[closeCaption.updatedLanguages.transcription_code] || '').toString()).toLowerCase().includes(searchKey);
    });

  }

};

export const addKeyword = (keywords: any, keyValue: string) => {
  keywords.push(keyValue);
  store.dispatch({
    type: Types.TRANSCRIPTS_ADD_KEYWORD,
    payload: {
      keywords: keywords
    }
  });
  toastInformation(keyValue + " Keyword added", "success");
};

export const storeTranscript = (transcripts:any) => {
  let transcriptData = store.getState().closeCaption.transcripts || [];
  transcriptData.push(transcripts);
  store.dispatch({
    type: Types.TRANSCRIPTS_LIST,
    payload: {
      transcripts: transcriptData
    }
  });
};

export const automatedFilesUpload = (data: any) => {
  store.dispatch({
    type: Types.TRANSCRIPT_FILE_UPLOAD,
    payload: {
      files:data
    }
  });
};

export const removeAttachedFiles = (fileNumber: number) => {
  let dataCloseCaption: closeCaptionmeetingState = store.getState().closeCaption;
  let file = dataCloseCaption.files || [];
  file.splice(fileNumber, 1);
  store.dispatch({
    type: Types.TRANSCRIPT_FILE_UPLOAD,
    payload: {
      files:file
    }
  });
  
};

export const storeMomData = (transcripts:any) => {
  let editautomatedmins = store.getState().closeCaption.editautomatedmins || [];
  editautomatedmins.push(transcripts);
};

export const playAudioDetails = (transText:any, audioLang:any) => {
  let langu = '', speaker = '';
  if (audioLang === "it") {
    langu = "it_it";
    speaker = "gina";
  } else if (audioLang === "fr") {
    langu = "fr_fr";
    speaker = "benoit";
  } else if (audioLang === "de") {
    langu = "de_de";
    speaker = "max";
  } else if (audioLang === "es") {
    langu = "es_es";
    speaker = "pilar";
  }
  if(langu && speaker){
    if(player.paused){
      player.src =`https://readspeaker.worktual.co.uk/rest/vtspeech?voice=${speaker}&lang=${langu}&
  &pitch=110&speed=96&srate=16000&aformat=ogg&text=${encodeURIComponent(_.unescape(transText))}`;
      player.play();
    }
  };
};

export const playAudio = (shiftArray:any) => {
  shiftArray.lang = shiftArray.lang==="en"?"en":shiftArray.lang;
  if (shiftArray.source_lang !== shiftArray.target_lang) {
    var axios = require('axios');
    var configs = {
      method: 'get',
      url: `${config().GOOGLE_API_URL}&q=${shiftArray.text}
      &target=${shiftArray.target_lang}&source=${shiftArray.source_lang}`,
      headers: {
        "X-HTTP-Method-Override": "GET"
      }
    };
    axios(configs)
      .then(function(response: any) {
        const translation = response.data?.data;
        if (translation && translation.translations && Array.isArray(translation.translations) &&
              translation.translations.length > 0 && translation.translations[0].translatedText) {
          playAudioDetails(translation.translations[0].translatedText,shiftArray.target_lang);
        }
      })
      .catch(function(error: any) { console.log(error); });
  }
};